import styled from 'styled-components';
import { Accordion, Grid, Label, Modal, Segment } from 'semantic-ui-react';

export const StyledGridRow = styled(Grid.Row)`
padding-bottom: 5px !important;
align-items: baseline !important;
flex-wrap: no-wrap !important;
`
export const StyledInfoRow = styled.div`
padding-bottom: 5px !important;
align-items: baseline !important;
flex-wrap: no-wrap !important !important;
width: 100%!important;
padding: 0;
padding-top: 1rem;
display: flex;
`
export const StyledGridColumns = styled(Grid.Row)`
font-weight: bold !important;
 .disabled{
  opacity: 1 !important;
 }
margin-right: 10px !important;
`
export const StyledAccordion = styled(Accordion)`
width: 100% !important;
margin-top: 15px;
 .title {
   display: flex;
   align-items: baseline;
   justify-content: space-between;
   color: black !important;
 }
`
export const StyledSegment = styled(Segment)`
background: white !important;
-webkit-box-shadow: none !important;
background-color: rgb(241 245 249) !important;
border: none !important;
border-radius: 1.3rem !important;
box-shadow: none !important;
padding: 15px;
padding-bottom: 15px !important;
 .column {
  -webkit-box-shadow: none !important;  
   box-shadow: none !important;
 }
 .header {
  margin-top: -1em !important;
  padding: 2rem 0rem 0rem 1rem !important;
  font-size: 18px !important;
 }
 .row {
  flew-wrap: no-wrap !important;
 }
`
export const TimePickerWrapper = styled.div`
 .react-datepicker__header{
    background-color: #216ba5 !important;
 }
 .react-datepicker-time__header {
   color: white !important;
 }
`
export const PlanModal = styled(Modal)`
 .header {
  text-align: center;
 }
 .content {
  text-align: center;
  font-size: 1.1em !important;
  padding: 2rem !important;
  > p{
    margin-bottom: 1.5rem !important;
  }
  > b{
    margin-bottom: 1.5rem !important;
  }
 }
`
export const StyledFileLabel = styled(Label)`
display: flex !important;
cursor: pointer;
width: 200px;
 .fileName {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
 }
`
export const ChangesWrapper = styled.div`
display: flex;
align-items: center;
gap: 10px;
 .icon {
  font-size: 1.5em !important;
 }
 .label {
  cursor: default !important;
 }
`